export type { AskDoctorV2ViewableOption } from './AskDoctorPracticeDialogContent.graphql';
export { AskDoctorPracticeDialogContent } from './AskDoctorPracticeDialogContent.graphql';
export * from './utils.graphql';
